import { render, staticRenderFns } from "./TenantSwitch.vue?vue&type=template&id=747e9bcb&scoped=true"
import script from "./TenantSwitch.vue?vue&type=script&lang=js"
export * from "./TenantSwitch.vue?vue&type=script&lang=js"
import style0 from "./TenantSwitch.vue?vue&type=style&index=0&id=747e9bcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e9bcb",
  null
  
)

export default component.exports